module.exports = __webpack_public_path__ + "img/هنری.266b919e.jpg";